import type { NamespaceSearchRequest } from '@unifyapps/network/generated/models/namespaceSearchRequest';

interface ComponentNamespacesByIdsParams {
  interfaceIds: string[];
  interfaceComponentIds: string[];
  locale: string;
}

export const getDeployedInterfaceComponentNamespacesByIdsSearchRequest = (
  params: ComponentNamespacesByIdsParams,
): NamespaceSearchRequest => {
  const { interfaceIds, interfaceComponentIds, locale } = params;

  return {
    interfaceIds,
    componentIds: interfaceComponentIds,
    locale,
    page: { limit: 100, offset: 0 },
  };
};

interface CommonNamespaceParams {
  interfaceId: string;
  locale: string;
}

export const getDeployedInterfaceCommonNamespaceSearchRequest = (
  params: CommonNamespaceParams,
): NamespaceSearchRequest => {
  const { interfaceId, locale } = params;

  return {
    interfaceIds: [interfaceId],
    locale,
    includeCommonNamespaces: true,
    page: { limit: 100, offset: 0 },
  };
};
